const sitePrefix = 'ELT-online-practice-help-docs-v2';

export const setSessionData = ({ key, value }) => {
  const fullKey = `${sitePrefix}-${key}`;
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(fullKey, value);
  }
};

export const getSessionData = (key) => {
  const fullKey = `${sitePrefix}-${key}`;

  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(fullKey);
  }
};



// WEBPACK FOOTER //
// ./src/components/sessionStorage/sessionStorage.js